module.exports = __webpack_public_path__ + "static/media/hygieneplan_aufgabe.0328aed7.jpg";